export default __webpack_public_path__ + "static/media/ciencia_um.563cf013.jpg";